import Joi from "joi";

export const code_schema = Joi.object({
  code: Joi.string().required(),
});
